module.exports = __webpack_public_path__ + "img/event-banner-02.af0c779d.jpg";